export default "__VITE_ASSET__DKtRjEX4__"